// src/Screens/FutureSelfLoader.jsx
import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import Lottie from 'lottie-react';
import animationData from '../Assets/future-self-loader-animation.json'; // Or use an image if you're not using Lottie

const FutureSelfLoader = () => {
  const navigate = useNavigate();

  useEffect(() => {
    const timer = setTimeout(() => {
      navigate('/future-self');
    }, 3000);

    return () => clearTimeout(timer);
  }, [navigate]);

  return (
    <div className="bg-white/80 backdrop-blur-md rounded-[30px] shadow-xl p-6 flex flex-col justify-center items-center min-h-[70vh] w-full max-w-[950px] mx-auto gap-8">
      {/* 👇 Use Lottie or replace with img src */}
      <div className="w-[300px] md:w-[400px] lg:w-[500px]">
        <Lottie animationData={animationData} loop={true} />
      </div>

      {/* 🧠 Kumar text */}
      <p className="text-lg md:text-xl font-semibold text-stone-800 font-sora text-center">
        Generating your future self... ✨
      </p>
    </div>
  );
};

export default FutureSelfLoader;
